import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import { environment } from '@environment';

const CORE_API_BASE_URL = environment.verifyApiBaseUrl;
const PUBLIC_KEY = environment.adminTenantPublicKey;

/**
 * ApplicationService
 * * Manages HTTP requests for the Application entity.
 * Handles creating new applications and updating existing ones.
 */
@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private http = inject(HttpClient);
  private tokenService = inject(TokenService);

  private getHeaders(): HttpHeaders {
    const token = this.tokenService.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'x-public-key': PUBLIC_KEY,
      'x-token-ready': 'true'
    });
  }

  /**
   * Creates a new application for a user.
   * * @param payload - The application data model (matching the Flutter CreateApplication payload).
   */
  createApplication(payload: any): Observable<any> {
    const url = `${CORE_API_BASE_URL}/applications`;
    return this.http.post(url, payload, { headers: this.getHeaders() });
  }

  /**
   * Updates an existing application by ID.
   * * @param id - The UUID of the application.
   * * @param payload - The partial or complete data to update.
   */
  updateApplication(id: string, payload: any): Observable<any> {
    const url = `${CORE_API_BASE_URL}/applications/${id}`;
    return this.http.patch(url, payload, { headers: this.getHeaders() });
  }
}